interface Environment {
    REACT_APP_API_URL: string;
    REACT_APP_FRONT_END_URL: string;
    REACT_APP_FACEBOOK_AUTHENTICATION_URL: string;
    REACT_APP_GOOGLE_AUTHENTICATION_URL: string;
}

export default (process.env as any) as Environment;